import { client, checkAndParseResponse, parseAxiosError } from "@/api";

export async function login(username, password) {
  const params = {
    grant_type: "password",
    scope: "*",
    username: username,
    password: password
  };
  try {
    const apiResponse = await client.post("/auth/token", params);
    if (apiResponse.data && apiResponse.data.access_token) {
      return apiResponse.data;
    } else {
      throw new Error("Authentication error");
    }
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function registerUser(oRequest) {
  try {
    const apiResponse = await client.post("jaHejuph32ub/register", oRequest);
    return apiResponse;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function me() {
  try {
    const apiResponse = await client.get("/me");
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function sendResetPasswordEmail(username, storefrontId) {
  try {
    const apiResponse = await client.post(`/password/email`, {
      username: username,
      storefront_id: storefrontId
    });
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function createKid(oParams) {
  try {
    const apiResponse = await client.post(`kid`, oParams);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function updateKid(kidId, oParams) {
  try {
    const apiResponse = await client.put(`kid/${kidId}`, oParams);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function getKids() {
  try {
    const apiResponse = await client.get(`kids`);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function addKidToOrder(orderId, kidId) {
  try {
    const oParams = {
      kid_id: kidId
    };
    const apiResponse = await client.post(`order/${orderId}/kid`, oParams);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}
